module.exports = __webpack_public_path__ + "assets/img/yy_ljyy-7ce721dd.png";